import { render, staticRenderFns } from "./TestFeedback.vue?vue&type=template&id=6ed375c6"
import script from "./TestFeedback.vue?vue&type=script&lang=js"
export * from "./TestFeedback.vue?vue&type=script&lang=js"
import style0 from "./TestFeedback.vue?vue&type=style&index=0&id=6ed375c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TestFeedback.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports